import {
    mapState,
    mapMutations
  } from 'vuex'
  import api from '../service/services'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.min.css'
  import swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/src/sweetalert2.scss'
  import moment from 'moment'
  
  const {
    detect
  } = require('detect-browser')
  const browser = detect()
  
  export default {
    name: 'detailfile',
    data() {
      return {
        data: [],
        isLoading: false,
        data_bill: [],
        data_images: [],
        count_images: 0,
        total_images: 0,
        zipfile: [],
        error_massage: '',
        perload: 0,
        selected: false,
        checkbox_data: [],
        isDownload: 0,
        current_page: 1,
        items_perpage: 20,
        result_count: 0,
        getData: false,
        paginateData: []
      }
    },
    components: {
      Loading
    },
    computed: {
      ...mapState(['user', 'url', 'os']),
      ...mapMutations(['setUser']),
      paginate: function () {
        this.result_count = this.data_images.length
        if (this.current_page >= this.totalPages) {
          this.current_page = Math.max(0, this.totalPages)
        }
        var index = this.current_page * this.items_perpage
        return this.data_images.slice(index, index + this.items_perpage)
      },
      totalPages: function () {
        return Math.ceil(this.result_count / this.items_perpage)
      }
    },
    methods: {
      getBill(key) {
        this.error_massage = 'Image processing system please wait...'
        var obj = {
          bill_key: key
        }
  
        api.AXbill(
          this.url,
          obj,
          result => {
            if (result.status === 1) {
              this.data = result.data
              this.data_bill = result.data.bill
              this.count_images = this.data_bill.cnt_upload
              this.total_images = this.data_bill.total_upload
              this.data_images = []
              result.data.images.forEach(val => {
                this.data_images.push({
                  // src: 'https://photogenius.sgp1.digitaloceanspaces.com/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                  src: '../PGws/PGDownload/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                  path: '../PGws/PGDownload/' + this.data_bill.bill_number + '/' + this.data_bill.bill_folder + '/' + val['image_name'],
                  name: val['image_name'],
                  id: val['id']
                })
              })
              setTimeout(function () {
                this.perload = Math.ceil((this.count_images / this.total_images) * 100)
                if (this.count_images !== this.total_images) {
                  this.getBill(key)
                } else {
                  if (this.data_bill.is_expire === '0') {
                    if (this.isDownload !== 1) {
                      this.downloadFolder(key)
                    } else {
                      if (this.total_images === '') {
                        this.error_massage = 'No Data images upload'
                      } else {
                        this.error_massage = ''
                        this.isDownload = 1
                      }
                      swal({
                        title: 'Picture in bill number ' + this.data_bill.bill_number + ' Expires within 120 days',
                        // title: 'Picture in bill number ' + this.data_bill.bill_number + ' will expire on ' + this.date_format(this.data_bill.expired_date),
                        animation: false,
                        type: 'warning',
                        customClass: 'animated tada'
                      })
                    }
                  } else {
                    window.location = 'https://drive.google.com/drive/u/1/folders/' + key
                  }
                }
              }.bind(this), 3000)
            } else {
              // this.isLoading = false
              this.isDownload = 1
              this.error_massage = result.data
              alert('error ' + JSON.stringify(result))
            }
          },
          error => {
            this.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      },
      downloadFolder (key) {
        this.isLoading = true
        var obj = {
          bill_key: key
        }
        this.error_massage = 'Image processing system please wait...'
        api.AXdownloadtmp(this.url,
          obj,
          result => {
            if (result.status === 1) {
              if (result.data.bill_cnt !== null) {
                this.count_images = result.data.bill_cnt
                this.total_images = result.data.bill_upload
                if (this.count_images !== this.total_images) {
                  this.downloadFolder(key)
                } else {
                  console.clear()
                  this.getBill(key)
                  this.error_massage = 'Image processing system please wait...'
                  setTimeout(function () {
                    this.isDownload = 1
                    this.isLoading = false
                    this.getData = true
                    this.setPage(1)
                  }.bind(this), 1500)
                }
              } else {
                this.downloadFolder(key)
              }
            } else {
              this.isLoading = false
              alert('error ' + JSON.stringify(result))
              this.error_massage = result.data
            }
          },
          error => {
            alert(JSON.stringify(error))
          })
      },
      downloadSelect() {
        this.isLoading = true
        if (this.checkbox_data.length > 0) {
          var obj = []
          this.checkbox_data.forEach(val => {
            obj.push({
              id: val
            })
          })
          obj = {
            bill_key: this.$route.params.key,
            image_ids: obj
          }
          api.AXzipfile(this.url, obj,
            result => {
              this.isLoading = false
              if (result.status === 1) {
                window.location = result.data.zipfile
                console.clear()
              } else {
                alert(JSON.stringify(result.data))
              }
              this.checkbox_data = []
              this.selected = false
            },
            error => {
              this.isLoading = false
              alert(JSON.stringify(error))
            })
        } else {
          this.selected = false
          this.isLoading = false
        }
      },
      downloadAll() {
        swal({
          title: 'Do you want to download all the photos?',
          text: 'Images are compressed into zip files for download. It may take about 2 minutes.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Download Now'
        }).then((result) => {
          if (result.value) {
            this.isLoading = true
            var obj = []
            this.data_images.forEach(val => {
              obj.push({
                id: val['id']
              })
            })
  
            obj = {
              bill_key: this.$route.params.key,
              image_ids: obj
            }
            api.AXzipfile(this.url, obj,
              result => {
                this.isLoading = false
                if (result.status === 1) {
                  window.location = result.data.zipfile
                  console.log('download all ' + JSON.stringify(obj))
                } else {
                  alert(JSON.stringify(result.data))
                }
                this.checkbox_data = []
                this.selected = false
              },
              error => {
                this.isLoading = false
                alert(JSON.stringify(error))
              })
          }
        })
      },
      scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          document.getElementById('button-to-top').style.display = 'block'
          document.getElementById('nav-bottom').style.display = 'block'
          document.getElementById('nav-top').style.display = 'none'
        } else {
          document.getElementById('button-to-top').style.display = 'none'
          document.getElementById('nav-bottom').style.display = 'none'
          document.getElementById('nav-top').style.display = 'block'
        }
      },
      topFunction() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      preview(id) {
        this.$router.push({
          name: 'ImagePreview',
          params: {
            key: this.$route.params.key,
            id: id
          }
        })
      },
      setPage(pageNumber) {
        this.getData = false
        this.current_page = pageNumber - 1
        var paginate = []
        if (pageNumber > 1) {
          paginate.push({
            text: '<<',
            number: 1
          }, {
            text: '<',
            number: pageNumber - 1
          })
        }
  
        if (this.totalPages > 3) {
          if (pageNumber > 1 && pageNumber !== 1) {
            paginate.push({
              active: false,
              text: 1,
              number: 1
            })
            if (pageNumber > 2) {
              paginate.push({
                active: false,
                text: '...',
                number: pageNumber - 1
              })
            }
          }
  
          var kk = 2
          for (var i = 0; i < 3; i++) {
            if (this.current_page < 4) {
              if (i === 0) {
                paginate.push({
                  active: true,
                  text: pageNumber,
                  number: pageNumber
                })
              } else {
                paginate.push({
                  active: false,
                  text: pageNumber + i,
                  number: pageNumber + i
                })
              }
            } else if (pageNumber >= this.totalPages) {
              if (i <= 1) {
                paginate.push({
                  active: false,
                  text: this.totalPages - (i + kk),
                  number: this.totalPages - (i + kk)
                })
              } else {
                paginate.push({
                  active: true,
                  text: this.totalPages,
                  number: this.totalPages
                })
              }
              kk = kk - 2
            } else {
              if (i === 0) {
                paginate.push({
                  active: false,
                  text: pageNumber - 1,
                  number: pageNumber - 1
                })
              } else if (i === 1) {
                paginate.push({
                  active: true,
                  text: pageNumber,
                  number: pageNumber
                })
              } else if (pageNumber < this.totalPages) {
                paginate.push({
                  active: false,
                  text: pageNumber + 1,
                  number: pageNumber + 1
                })
              }
            }
          }
        } else {
          for (var s = 1; s <= this.totalPages; s++) {
            if (s === pageNumber) {
              paginate.push({
                active: true,
                text: pageNumber,
                number: pageNumber
              })
            } else {
              paginate.push({
                active: false,
                text: s,
                number: s
              })
            }
          }
        }
  
        if (pageNumber !== (this.totalPages - 1) && pageNumber !== this.totalPages) {
          if (paginate[6]) {
            if (paginate[6].number !== this.totalPages) {
              paginate.push({
                active: false,
                text: '...',
                number: pageNumber + 1
              })
              paginate.push({
                active: false,
                text: this.totalPages,
                number: this.totalPages
              })
            }
          } else {
            paginate.push({
              active: false,
              text: '...',
              number: pageNumber + 1
            })
            paginate.push({
              active: false,
              text: this.totalPages,
              number: this.totalPages
            })
          }
        }
  
        if (pageNumber < this.totalPages) {
          if (pageNumber !== this.totalPages) {
            paginate.push({
              active: false,
              text: '>',
              number: pageNumber + 1
            })
            paginate.push({
              active: false,
              text: '>>',
              number: this.totalPages
            })
          }
        }
        this.paginateData = paginate
        setTimeout(function () {
          this.getData = true
        }.bind(this), 1500)
      },
      date_format(date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    created() {
      window.addEventListener('scroll', this.scrollFunction)
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollFunction)
    },
    mounted() {
      this.getBill(this.$route.params.key)
      this.$store.state.os = browser.os
      this.error_massage = 'Image processing system please wait...'
      if (sessionStorage.getItem('users') !== null) {
        this.$router.push({
          name: 'BillDetail',
          params: {
            key: this.$route.params.key
          }
        })
      } else {
        this.$router.push({
          name: 'Detail',
          params: {
            key: this.$route.params.key
          }
        })
  
        try {
          this.setUser()
        } catch (e) {
          // location.reload()
        }
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/js/detail_file.js